module.exports = __webpack_public_path__ + "img/pink1.ef3bd8b2.jpg";